// Constant for EVM Log Trigger type - used to identify and render special UI
export const EVM_LOG_TRIGGER_TYPE = "evm-log";
